import type { DefaultTheme } from "react-jss";

import { commonLightTheme } from "@/theme/themes/common.light";

export const olearysLightTheme: DefaultTheme = {
  ...commonLightTheme,
  blobStorage: {
    ...commonLightTheme.blobStorage,
    brandLogo:
      "https://assets.markus.live/03-order-app/light/logo/logo-olearys.svg",
    burgerMenuLinks: [
      "https://assets.markus.live/00-generic-app/icons/logo/ApolloClub24.svg",
    ],
  },
  color: {
    ...commonLightTheme.color,
    productRowFeaturedBg: "#FFDC1E",
    productRowFeaturedText: "#101010",
    menuBlockTitle: "#292929",
    subCategoriesText: "#2d2d2d",
  },
  config: {
    ...commonLightTheme.config,
    brandLogoWidth: 104,
    brandLogoHeight: 40,
    sectionsColors: "#96BEAF;#2D9B87",
  },
} as const;
